// What a plate or slant is photographed as in the lab (photo_type, 0018).
// Shared by the plate detail's photo section (pages/Plates.js) and the home
// hub's quick "Lab photo" action (components/hub/quick), so the two offer the
// same choices.
export const LAB_PHOTO_TYPES = ['plate_photo', 'fruiting_body_lab', 'microscopy', 'spore_print', 'other'];
